var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100vh" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.onCancel()
                },
              },
            },
            [_c("w-fa", { staticClass: "mts mr", attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        { style: { padding: "0 0 0 0", height: "calc(100vh - 56px)" } },
        [
          _c("app-fixed-asset-edit-card", {
            on: {
              close: function ($event) {
                return _vm.onCancel()
              },
              refresh: function ($event) {
                return _vm.onRefresh()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }